import React from 'react';
import styled from 'styled-components';
import YouTube from 'react-youtube';

const YT = styled(YouTube)`
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  position: absolute;
`;

const Container = styled.div`
  width: 100%;
  margin: auto;
  height: 100%;
  position: relative;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding: 1rem;
`;

const YoutubeEmbed = ({ youtubeVideoId }) => {
  const onEnd = () => {
    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        key: '39',
        code: 'ArrowRight',
        shiftKey: false,
        ctrlKey: false,
        metaKey: false,
      })
    );
  };

  return (
    <Container>
      <YT
        id={youtubeVideoId}
        videoId={youtubeVideoId}
        onEnd={onEnd}
        opts={{ playerVars: { autoplay: 1, controls: 0, showinfo: 0, rel: 0 } }}
      />
    </Container>
  );
};

export const VideoStep = ({ data }) => {
  const { youtubeVideoId } = data.currentStep;

  return <Wrapper>{youtubeVideoId ? <YoutubeEmbed {...{ youtubeVideoId }} /> : 'VIDEO'}</Wrapper>;
};
